import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { isAdmin, isStaff } from '../../../../common/typeAssertionFunctions';
import useAuthStore from '../../../../datastore/useAuth';
import useLoyaltyPointConversionRates from '../../../../datastore/useLoyaltyPointConversionRates';
import useLoadingModal from '../../../../hooks/useLoadingModal';
import { formatPaymentType, PaymentType } from '../../../../common/enums';


export default function LoyaltyPointsSettings() {
    const { currentUser } = useAuthStore()
    const { currentRate, create } = useLoyaltyPointConversionRates()
    const { loading, setLoading } = useLoadingModal()
    const [newRate, setNewRate] = useState<number | null>(null)

    const onSubmitNewRate = async () => {
        if (!newRate) return;
        setLoading(true)
        await create(newRate)
        setLoading(false)
        setNewRate(null)
    }

    if (!currentUser || !isStaff(currentUser)) return null


    return (
        <>
            <Divider />
            <Stack direction="column" spacing={4} sx={{ alignItems: 'flex-start', justifyContent:'flex-start', paddingY: 2 }}>
                <Typography variant="h4">
                    {formatPaymentType(PaymentType.LoyaltyPoints)} Conversion Rate: {currentRate ? `${currentRate.pointsToOneDollar} points => $1` : 'NOT SET'}
                </Typography>
                {
                    isAdmin(currentUser) && (
                        <Stack direction="row" spacing={4} sx={{ alignItems: 'center', justifyContent:'flex-start', paddingBottom: 2 }}>
                        <Typography>Set New Conversion Rate</Typography>
                            <TextField
                                type="number"
                                slotProps={{
                                    htmlInput: {
                                        min: 1,
                                        step: 1
                                    }
                                }}
                                value={newRate || ''}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewRate(e.target.value ? +e.target.value : null)}
                            />
                            <Button type="submit" variant='contained' onClick={onSubmitNewRate} disabled={!newRate || loading}>Set</Button>
                        </Stack>
                    )
                }

            </Stack>
        </>

    )
}